import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent, moduleTypeNames } from "../../../framework/core/mvvm/module_base";
import ClubAddGameView from "./club_add_game_view";
import ModuleManager from "../../../framework/core/module_manager";
import ClubRuleMgrModule from "./club_rule_manager_module";
import ClubGameSettingModule from "./club_game_setting_module";



const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit("ClubAddGameModule")
export default class ClubAddGameModule extends ModuleBase<ClubAddGameView,null> {

    /**
     * 游戏列表
     */
    private gamelist : any[] = [];
    

    constructor(){
        super();
        this.layer = ViewLayer.Mid;
        this.modelType = null;
        this.viewType = ClubAddGameView;
        this.needViewMask = true
        this.clickAnywhereClose = false;
        this.windowPrefabResPath = "package/club/module/club_add_game"
    }

    onLoad(){

        this.eventBind("club_choose_add_game",this.onChoose);
    }

    /**
     * 增加游戏
     */
    private onChoose(index : number){

        console.log(" onChoose ",index);
        let game = this.gamelist[index];


        ModuleManager.instance.showModule(ClubGameSettingModule,{ gameData : game,source : "addgame"},()=>{
            this.hide();
        });
    }


    @bindButtonClickEvent("return")
    onReturn(){

        //返回玩法管理..        
        ModuleManager.instance.showModule(ClubRuleMgrModule,null,()=>{
            this.hide();
        });
    }
    
    @bindButtonClickEvent("serach_button")
    onSearch(){
        //根据名字搜索游戏
        let search = this.view.serachEditBox.string;
    }
      
    @bindButtonClickEvent("close")
    onClose(){

        this.hide();
    }

    onShow(){

        this.updateGameList();
    }

    updateGameList(){
        
        //test..
        for (let index = 0; index < 15; index++) {
            this.gamelist[index] = 0;            
        }
        this.view.createItems(this.gamelist);
    }



}
